// Ledger Getters

export const getLedgerList = state => {
  return state.ledgerList
}

export const getLedgerDetailList = state => {
  return state.ledgerDetailList
}
